import { CourseLite, CourseOption, CourseSummary } from '../types/course.response';

export const getCornellClassesUrl = (courseOption: CourseOption): string | null => {
    const semester = courseOption.enrollGroups?.[0]?.semester;
    if (!semester) return null;

    return `https://classes.cornell.edu/browse/roster/${semester}/class/${courseOption.courseInfo.subject}/${courseOption.courseInfo.number}`;
};

export const getCourseId = (courseOption: CourseLite): string => {
    return courseOption.id;
};

export const getCourseTopic = (courseOption: CourseLite): string => {
    return courseOption.topic;
};

export const getUserItemId = (courseOption: CourseLite): number | null => {
    return courseOption.userItemId;
};

export const getCourseCredit = (courseOption: CourseOption | CourseSummary): number => {
    if ('creditsMinimum' in courseOption) {
        return courseOption.creditsMinimum ?? 0;
    }
    return courseOption.enrollGroups?.[0]?.creditsMinimum ?? 0;
};

export const getCourseKey = (courseOption: CourseLite): string => {
    return `${courseOption.id}-${courseOption.topic || ''}`;
};

/** 后端 courses 字典 key 的口径(server course-key.ts):topic 非空 → `id::topic`,否则 `id` */
export const getBackendCourseKey = (course: { id: string; topic: string }): string => {
    return course.topic ? `${course.id}::${course.topic}` : course.id;
};

export const getCourseIsSaved = (courseOption: CourseLite): boolean => {
    return courseOption.userState.isSaved;
};

export const getCourseSemester = (courseOption: CourseLite): string | null => {
    return courseOption.userState.semester;
};
